import {CPA_CONNECTION_ROUTE} from 'coreUtils/cms/contentHubConnection';
import type {ICpaConnectionOverride} from 'coreUtils/cms/contentHubConnection';

/**
 * Sends the connection override to the server, which validates it and stores it in httpOnly cookies.
 * @param {ICpaConnectionOverride} override - Values to override (empty ones keep the instance defaults)
 * @returns {Promise<string[]>} Invalid fields, empty when saved
 */
export const saveCpaConnection = async (override: ICpaConnectionOverride): Promise<string[]> => {
	const response = await fetch(CPA_CONNECTION_ROUTE, {
		method: 'POST',
		headers: {'Content-Type': 'application/json'},
		credentials: 'same-origin',
		body: JSON.stringify(override),
	});

	if (response.ok) {
		return [];
	}

	const body = await response.json().catch(() => null);

	return body?.errors?.length ? body.errors : [`status ${response.status}`];
};

/**
 * Removes the connection override: the preview goes back to the CMS of the instance.
 * @returns {Promise<void>}
 */
export const clearCpaConnection = async (): Promise<void> => {
	await fetch(CPA_CONNECTION_ROUTE, {method: 'DELETE', credentials: 'same-origin'}).catch(() => null);
};
